import Vue from 'vue'
import ProductItemsService from 'js/services/api/billing/product-items.js'
import ProductValidationsService from 'js/services/api/billing/product_validations.js'

import ProductDataMixin from '../_product-data.js'

import TransactionsTab from './_tabs/transactions'
import InfoTab from './_tabs/info'

import template from './index.pug'

const TRANSACTION_TAB = {
  id: 0,
  label: 'balance.products.tabs.transactions',
  component: TransactionsTab
}
const INFO_TAB = {
  id: 1, 
  label: 'balance.products.tabs.info',
  component: InfoTab
}

// @vue/component
export default {
  template: template(),

  components: {TransactionsTab, InfoTab},

  mixins: [ProductDataMixin],

  props: {
    productId: {
      type: String
    },
    currentTab: {
      type: String
    }
  },

  data() {
    return {
      product: undefined,
      productTransactions: {},
      tab: 0,
      tabs: [TRANSACTION_TAB, INFO_TAB],
      pagination: {
        currentPage: 1,
        limit: 10,
        totalElements: null
      }
    }
  },

  computed: {

  },

  created() {
    this.tabHistorical()
    this.getProduct()
  },

  methods: {
    async getProduct() {
      this.product = await ProductItemsService.show(this.productId)
      const params = {
        status: 'active',
        administrative_area_id: this.$currentAccount.administrative_area_id,
        has_qr_available: true,
        order_by: 'operation_date',
        product_item_code: this.product.code,
        order_dir: 'desc',
        per: 50
      }
      this.productTransactions = await ProductValidationsService.index(params)
      this.pagination.totalElements = this.productTransactions.length
      const firstPosition = (this.pagination.currentPage - 1) * this.pagination.limit
      // eslint-disable-next-line max-len
      this.productTransactions = this.productTransactions.slice(firstPosition, firstPosition + this.pagination.limit)
    },

    isTabActive(tab) {
      return tab.id === this.tab
    },

    loadImg() {
      if (this.product && this.product.product_logo) {
        return product.product_entity_product_logo.url
      } else if (this.$store.getters.currentAppConfig.default_logo_url) {
        return this.$store.getters.currentAppConfig.default_logo_url
      }

      return null
    },

    changeTab(index) {
      this.tab = this.tab === index ? null : index
    },

    changeLimit(limit) {
      this.pagination.limit = limit
      this.pagination.currentPage = 1
      this.getProduct()
    },
    changePage(page) {
      this.pagination.currentPage = page
      this.getProduct()
    },
    tabHistorical() {
      if (this.currentTab === 'historical') {
        this.tabs = [INFO_TAB]
        this.tab = 1
      }
    }

  }
}
